export const formatNumber = ({
  number,
  thousandSeparator = '.',
  groupOfDigitsLength = 3,
  decimalSeparator = ',',
  minDecimals = 0,
  maxDecimals = 10,
  abbreviation = 'round'
}) => {
  if (typeof number !== 'number') {
    return number;
  }
  let abbreviatedNumber;
  if (abbreviation === 'none') abbreviatedNumber = number;
  else {
    abbreviatedNumber = abbreviation === 'round' ? Math.round(number * (10 ** maxDecimals)) / (10 ** maxDecimals) : Math.trunc(number * (10 ** maxDecimals)) / (10 ** maxDecimals);
  }
  const members = `${abbreviatedNumber}`.split('.');
  const [integerAsString] = members;
  let [, decimalsAsString = ''] = members;
  const len = integerAsString.length;
  const stack = [];
  for (let i = 0; i < len; i += 1) {
    if (i !== 0 && (i % groupOfDigitsLength) === 0) {
      stack.unshift(thousandSeparator);
    }
    stack.unshift(integerAsString.charAt(len - 1 - i));
  }
  if (minDecimals > 0 || decimalsAsString.length > 0) {
    const diff = minDecimals - decimalsAsString.length;
    if (diff > 0) {
      for (let i = 0; i < diff; i += 1) {
        decimalsAsString += '0';
      }
    }
    if (maxDecimals !== undefined) {
      decimalsAsString = decimalsAsString.substring(0, maxDecimals);
    }
    stack.push(decimalSeparator, decimalsAsString);
  }
  return stack.join('');
};

/**
 * Formatea números de acuerdo a las reglas de cada país
 * @number {number} Número a formatear
 * @country {string} Locale del país (this.$i18n.locale)
 * @usePrefix {boolean} Usar o no el prefijo de la moneda
 * @usePrimaryCurrency {boolean} Usar moneda primaria. Sólo para country='cl', si es true, usa UF, sino, usa CLP.
 */
export const formatNumberByCountry = ({
  number,
  countryIn,
  usePrefix = true,
  fractionDigits = 2,
  currencyType = 'secondary'
}) => {
  const formatLocales = {
    br: {
      primary: {},
      secondary: {
        prefix: 'R$ ',
        thousandSeparator: ',',
        decimalSeparator: '.',
        minDecimals: fractionDigits,
        maxDecimals: fractionDigits
      }
    },
    cl: {
      primary: {
        prefix: 'UF ',
        thousandSeparator: '.',
        decimalSeparator: ',',
        minDecimals: fractionDigits,
        maxDecimals: fractionDigits
      },
      secondary: {
        prefix: '$ ',
        thousandSeparator: '.',
        decimalSeparator: ',',
        minDecimals: fractionDigits,
        maxDecimals: fractionDigits
      }
    },
    pe: {
      primary: {},
      secondary: {
        prefix: 'S/ ',
        thousandSeparator: ',',
        decimalSeparator: '.',
        minDecimals: fractionDigits,
        maxDecimals: fractionDigits
      }
    }
  };
  const { prefix, thousandSeparator, decimalSeparator, minDecimals, maxDecimals } = formatLocales[countryIn][currencyType];
  const formattedNumber = formatNumber({ number, thousandSeparator, groupOfDigitsLngth: 3, decimalSeparator, minDecimals, maxDecimals });
  return `${prefix && usePrefix ? `${prefix}` : ''}${formattedNumber}`;
};
